<block-ui>
  <div style="padding:10px">
    <div *ngIf="this.planItem">
      <div class="table-title">Item Notes for {{this.planItem.value}}</div>
    </div>
    <div *ngIf="this.planItem">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="row">
          <button class="col-2" type="button" (click)="addItemNote()">Add</button>
        </div>
        <ng-container *ngIf="itemNotes" formArrayName="itemNotes">
          <ng-container *ngFor="let itemNote of itemNotes.controls; let i = index;"> 
            <div *ngIf="this.editItemNoteIndex === i" style="background-color: lightblue;">
              <div class="row" [formGroup]="itemNote">
                <div class="col-10">
                  <div class="row">
                    <div class="col" *ngIf="this.allowedRecipients && this.allowedRecipients.length == 1">
                      <b>To: </b> {{ this.allowedRecipients[0].display }}
                    </div>
                    <div class="col" *ngIf="this.allowedRecipients && this.allowedRecipients.length > 1">
                      <b>To: </b>
                      <mat-form-field appearance="fill">
                        <mat-select formControlName="toId">
                            <mat-option *ngFor="let option of this.allowedRecipients" [value]="option.value">
                              {{option.display}}                            
                            </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col">
                      <b>Type: </b>
                      <mat-form-field appearance="fill">
                        <mat-select formControlName="noteType">
                            <mat-option *ngFor="let option of this.noteTypes" [value]="option.value">
                              {{option.display}}                            
                            </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <button class="col-2" (click)="this.editItemNoteIndex = -1;" type="button" >
                  Close
                </button>
              </div>
              <div class="row" [formGroup]="itemNote">
                <mat-form-field *ngIf="itemNote.controls.noteType.value === 'TEXT'" class="col-12" appearance="fill">
                  <input matInput type="text" formControlName="value" placeholder="What do you want to say?">
                </mat-form-field>
                <div *ngIf="itemNote.controls.id.value === 0 && itemNote.controls.noteType.value === 'MP4'" class="col-12" appearance="fill">
                  <label>MP4</label>
                  <input type="file" accept=".mp4" (change)="onFileChange(i, $event)">
                </div>
                <div *ngIf="itemNote.controls.id.value != 0 && itemNote.controls.noteType.value === 'MP4'" class="col-12" appearance="fill">
                  <label>MP4</label>
                  {{ itemNote.controls.value.value }}
                </div>
              </div>
            </div>
            <div *ngIf="this.editItemNoteIndex != i" [ngClass]="{'evenRow':i % 2 == 0, 'oddRow': i % 2 != 0, 'clickable': itemNote.controls.member.value.id === this.member.id}" (click)="this.setEditItemNote(i);">
              <div class="row">
                <div class="col-5">
                  <b>From: </b>
                  {{ itemNote.controls.member.value.knownAs }}
                </div>
                <div *ngIf="itemNote.controls.to.value == null" class="col-5">Public</div>
                <div *ngIf="itemNote.controls.to.value != null && itemNote.controls.member.value.id != this.itemNote.controls.to.value.id" class="col-5"><b>To: </b>{{ itemNote.controls.to.value.knownAs }}</div>
                <div *ngIf="itemNote.controls.to.value != null && itemNote.controls.to.value.id === this.member.id && itemNote.controls.member.value.id === this.itemNote.controls.to.value.id" class="col-5">Private</div>
                <button class="delete-btn col-2" (click)="deleteItemNote(i)" type="submit" [disabled]="!form.valid">
                  Delete
                </button>
              </div>    
              <div *ngIf="itemNote.controls.noteType.value === 'TEXT'" class="col-12" style="word-wrap: break-word">{{ itemNote.controls.value.value }}</div>
              <div *ngIf="itemNote.controls.noteType.value === 'MP4' && itemNote.id != 0" class="col-12">
                <video width="320" height="180" controls>
                  <source src="{{ itemNote.controls.value.value }}" type="video/mp4">
                  Your browser does not support the video tag.
                </video>
              </div>
              <div *ngIf="itemNote.controls.noteType.value === 'MP4' && itemNote.id == 0" class="col-12">
                {{ itemNote.controls.member.value.knownAs }}
              </div>
            </div>
          </ng-container>
        </ng-container>
        <div class="row">
          <p *ngIf="!form.valid">Complete the form to enable button.</p>
          <button class="col-6" id=submit name=submit type="submit" [disabled]="!form.valid">Save Changes</button>
      </div>
      </form>
    </div>
  </div>
</block-ui>

